import * as React from 'react';
import * as ReactDOM from 'react-dom';
import '@babel/polyfill';
import { StudentRegistration } from '../components/screens/StudentRegistration/StudentRegistration';
import { parseUxMode } from '../frontendBackend';
import { attemptRegisterForDevs } from '../dev/dev-barrier/register';
import { setWebpackPublicFromBackend } from '../utility/customize-webpack';

let StudentRegisterRoot: any = StudentRegistration;

if (process.env.NODE_ENV === 'development') {
  // Enable hot module reload for dev builds
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { hot } = require('react-hot-loader');
  StudentRegisterRoot = hot(module)(StudentRegistration);
}

const registerDiv = document.querySelector('#register');
const backend = parseUxMode();

if (backend && registerDiv) {
  setWebpackPublicFromBackend();

  attemptRegisterForDevs();

  ReactDOM.render(
    <StudentRegisterRoot
      relayState={backend.relayState}
      errors={backend.errors}
      email={backend.email}
      uxmode={backend}
    />,
    registerDiv
  );

  const html = document.querySelector('html');
  if (html) {
    html.setAttribute('lang', 'en');
  }
}
